import { Attribution } from '../utility/unsplash';

export enum Studio {
  dashboard = 'story-manager',
  creator = 'creator',
  content = 'content',
  brandKit = 'brand-kit',
}

export enum ContentTab {
  video_clip = 'Video Clips',
  pull_quotes = 'Shareable Images',
  blog = 'Articles',
  social_posts = 'Social Posts',
  email = 'Email',
  talking_point_studio = 'Talking Points',
  media = 'Media',
  transcript_editor = 'Transcript',
}

export enum SidebarOption {
  aiProducer = 'ai_producer',
  media = 'media',
  karaoke = 'karaoke',
  text = 'text',
  editing = 'editing',
  history = 'history',
}

export enum AIProducerCard {
  story = 'story',
  clip = 'clip',
  music = 'music',
  photo = 'photo',
  sound_effect = 'sound_effect',
  retention_edit = 'retention_edit',
}

export enum MediaCard {
  photo = 'photo',
  music = 'music',
  video = 'video',
}

export type PunchListImageGeneration = {
  id: string;
  prompt: string;
  title: string;
  stock_keywords: string;
  dalleImages: Record<'uploadId' | 'uploadUrl', string>[];
};

export type PunchListItemReplacement = {
  type: ImageKey;
  url: string;
  aspectRatio: number;
  alt: string;
  id: string;
};

export type TranscriptContextMenuActions =
  | 'replace'
  | 'hideKaraoke'
  | 'showKaraoke'
  | 'removeText'
  | 'removePhoto'
  | 'addPhoto'
  | 'saveAsClip'
  | 'removeTextLoading'
  | 'removePhotoLoading'
  | 'addPhotoLoading'
  | 'restore'
  | 'cutText'
  | 'pasteTextBefore'
  | 'pasteTextAfter'
  | 'editTiming';

type Img = {
  url: string;
  alt: string;
  id: string;
};
export type ImageKey = 'ai' | 'stock' | 'artifact' | 'quotes';

export type ImageWithType = {
  [key in ImageKey]: Img & {
    type: key;
    width: string;
    height: string;
    fileName?: string;
    alt?: string;
    description?: string;
  } & (key extends 'ai' ? { id: string } : {}) &
    (key extends 'stock' ? { attribution?: Attribution } : {}) &
    (key extends 'quotes' ? { quote?: string } : {});
};

export enum MediaSubType {
  all = 'All Media',
  artifact = 'Artifacts',
  video = 'Videos',
  stock = 'Stock',
  ai = 'AI Generated',
}

export type TalkingPointContent = Record<
  'summary' | 'narrative' | 'impact' | 'quote' | 'takeaway' | 'donation',
  Record<'prompt' | 'content', string>
>;

export type BlogOrEmailContent = {
  id: number;
  title: string;
  content: string;
  username: string;
};

export enum GenericPresetTemplates {
  default = 'default',
  custom = 'custom',
}

export enum KaraokePresetTemplates {
  edge = 'edge',
  classic = 'classic',
  typewriter = 'typewriter',
  blackAndWhite = 'blackAndWhite',
}
